import * as React from 'react';
import { snap, story, visualize } from 'storybook-snapper';
import { TagSkin, Tag } from '..';
import { classes } from './Tag.visual.st.css';
import { VisualAsync } from '../../test/visual/VisualAsync';
import { tagDriverFactory } from './Tag.driver';

const noop = () => {};

visualize('Tag', () => {
  story('simple', () => {
    snap('default props', <Tag>Tag Name</Tag>);
    snap('light skin', <Tag skin={TagSkin.light}>Tag Name</Tag>);
    snap(
      'clickable',
      <Tag onClick={noop} skin={TagSkin.light}>
        Tag Name
      </Tag>,
    );
    snap(
      'removable',
      <Tag isRemovable onRemove={noop} skin={TagSkin.light}>
        Tag Name
      </Tag>,
    );
  });

  story('styles overrides', () => {
    snap(
      'default',
      <Tag onClick={noop} className={classes.styled}>
        Tag Name
      </Tag>,
    );
    snap(
      'wst override font',
      <Tag className={classes.wstFontOverride}>Libre Baskerville</Tag>,
    );
    snap(
      'wst override solid',
      <Tag className={classes.wstStyledSolid}>Tag Name</Tag>,
    );

    snap(
      'wst override light',
      <Tag skin={TagSkin.light} className={classes.wstStyledLight}>
        Tag Name
      </Tag>,
    );
  });

  story('focus', () => {
    snap('clickable', (done) => (
      <VisualAsync
        driverFactory={tagDriverFactory}
        onDone={done}
        action={(driver) => driver.click()}
      >
        <Tag onClick={noop} skin={TagSkin.light}>
          Tag Name
        </Tag>
      </VisualAsync>
    ));
    snap('removable', (done) => (
      <VisualAsync
        driverFactory={tagDriverFactory}
        onDone={done}
        action={(driver) => driver.click()}
      >
        <Tag isRemovable onRemove={noop} skin={TagSkin.light}>
          Tag Name
        </Tag>
      </VisualAsync>
    ));
  });

  story('hover', () => {
    const Hovered: React.FC<{
      className?: string;
      onDone: () => void;
      skin?: TagSkin;
    }> = ({ className, onDone, skin }) => (
      <VisualAsync
        driverFactory={tagDriverFactory}
        onDone={onDone}
        action={async (driver) => {
          await driver.setForceHover(true);
        }}
      >
        <Tag
          onClick={noop}
          skin={skin}
          className={`${className || ''} ${classes.hoveredTag}`}
        >
          Tag Name
        </Tag>
      </VisualAsync>
    );

    snap('solid default', (done) => <Hovered onDone={done} />);
    snap('solid wst override', (done) => (
      <Hovered onDone={done} className={classes.wstHover} />
    ));
    snap('solid tpa override', (done) => (
      <Hovered onDone={done} className={classes.tpaHover} />
    ));

    snap('light default', (done) => (
      <Hovered skin={TagSkin.light} onDone={done} />
    ));
    snap('light wst override', (done) => (
      <Hovered
        skin={TagSkin.light}
        onDone={done}
        className={classes.wstHover}
      />
    ));
    snap('light tpa override', (done) => (
      <Hovered
        skin={TagSkin.light}
        onDone={done}
        className={classes.tpaHover}
      />
    ));
  });
});
